import React from "react";
import { useSelector } from "react-redux";

import StockTable from "../../stock-table";
import { StockFilter } from "./stock-filter";

export const FilterStocks = () => {
  const stocks = useSelector((state) => state.filteredStocks?.data ?? []);

  return (
    <>
      <StockFilter />
      <StockTable stocks={stocks} showUpdated />
    </>
  );
};
